import { useLocation } from "react-router";
import { servicesData } from "../utils/constants";
import { ServicesComponentProps } from "../utils/interfaces";
import { useEffect } from "react";
import SEO from "./SEO";

const ServicesPage = () => {
  const params = useLocation();
  const moveToId = params.hash ? params.hash.substring(1) : "";

  useEffect(() => {

    if (moveToId && moveToId !== "ui-ux-design" && moveToId !== "game-development") {
      const element = document.getElementById(moveToId);
      if (element) {
        const offset = 0; // Adjust the offset value as per your needs (negative value for extra top space)
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition + offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }else if(moveToId === "game-development"){
      setTimeout(() => {
        const scrollHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
        );

        window.scrollTo({
          top: scrollHeight,
          behavior: "smooth",
        });
      }, 100);
      }else {
      window.scrollTo(0, 0);
    }
  }, [moveToId]);


  return (
    <>
      <SEO
        title="Our Services - Web Development, Mobile Apps, AI/ML Solutions | Nexasoft Infotech"
        description="Comprehensive software development services including modern web development with React.js and Next.js, cross-platform mobile apps, AI/ML integration, cloud-native solutions, and premium UI/UX design."
        keywords="web development services, mobile app development, React.js development, Next.js development, AI ML solutions, cloud-native applications, UI UX design, software development services"
        url="https://nexasoftinfotech.com/service"
      />
      {servicesData.map((data, index) => (
        <ServicesItem
          key={data.id}
          id={data.id}
          imageLocation={index % 2 === 0 ? "left" : "right"}
          imagePath={data.imagePath}
          data={data.data}
          mainTitle={data.mainTitle}
          subTitle={data.subTitle}
          description={data.description}
        />
      ))}
    </>
  );
};

export default ServicesPage;

const ServicesItem = ({
  id,
  imagePath,
  data,
  mainTitle,
  subTitle,
  description,
  imageLocation,
}: ServicesComponentProps) => {
  return (
    <div
      id={id}
      className={`grid 800:grid-cols-2 gap-6 500:gap-8 px-p83 ${
        imageLocation === "right" ? "bg-neutral-800" : "bg-gradient-to-br from-neutral-900 to-neutral-800"
      }  py-12 500:py-16 items-center min-h-[90vh]`}
    >
      {imageLocation === "left" && (
        <div  className="flex justify-start">
          <img src={imagePath} alt={`${mainTitle} ${subTitle} - Nexasoft Infotech Services`} className="max-[800px]:mx-auto rounded-md" loading="lazy" />
        </div>
      )}

      <div className="max-[800px]:order-1">
        <h3 className="text-2xl 500:text-3xl 700:text-4xl font-merry-bold tracking-tight">
          <span className="text-primary-500 font-bold"> {mainTitle}</span> {subTitle}
        </h3>
        <p className="py-4 500:py-5 text-sm 500:text-base font-poppins-regular text-neutral-300 leading-relaxed">{description}</p>
        {data.map((data: any, index: number) => (
          <div key={index} className="mb-4">
            <span className="flex items-center">
              <img
                src="/icons/DOT.svg"
                width={20}
                alt=""
                className="mr-3"
                aria-hidden="true"
              />
              <h4 className="font-poppins-semi-bold text-lg 500:text-xl text-neutral-100">{data.heading}</h4>
            </span>
            <p className="text-neutral-300 font-poppins-regular text-sm 500:text-base py-2 pl-8 leading-relaxed">{data.content}</p>
          </div>
        ))}
      </div>
      {imageLocation === "right" && (
        <div className="flex justify-end">
          <img src={imagePath} alt="Android" className="max-[800px]:mx-auto rounded-md" />
        </div>
      )}
    </div>
  );
};
